import { createFileRoute } from "@tanstack/react-router";
import PricingPage from "@/pages/PricingPage";
import { createTranslationInstance } from "@/i18n";
import { publicLanguageLinks } from "@/lib/publicLocale";

export const Route = createFileRoute("/fr/pricing")({
  head: () => {
    const translations = createTranslationInstance("fr");
    const title = `${translations.t("pricing.badge")} | System Atlas`;
    const description = `${translations.t("offerDetails.freeSheets")}. ${translations.t("pricing.freeTrial")}. ${translations.t("offerDetails.card")}`;
    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "fr_FR" },
        { property: "og:url", content: "https://systematlas.fr/fr/pricing" },
        { name: "twitter:card", content: "summary" },
        { name: "twitter:title", content: title },
        { name: "twitter:description", content: description },
      ],
      links: [
        { rel: "canonical", href: "https://systematlas.fr/fr/pricing" },
        ...publicLanguageLinks("/pricing"),
      ],
    };
  },
  component: PricingPage,
});